import React, { useEffect } from 'react';
import { Alert, Button, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const AdminImpersonationBanner = () => {
  const { adminImpersonation, logout } = useAuth();

  useEffect(() => {
    // Add padding to body when banner is visible
    if (adminImpersonation) {
      document.body.style.paddingTop = '68px';
    } else {
      document.body.style.paddingTop = '0px';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.paddingTop = '0px';
    };
  }, [adminImpersonation]);

  if (!adminImpersonation) {
    return null;
  }

  return (
    <Alert 
      severity="warning" 
      sx={{ 
        position: 'fixed', 
        top: 0, 
        left: 0, 
        right: 0, 
        zIndex: 9999,
        borderRadius: 0,
        '& .MuiAlert-message': {
          width: '100%'
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span>
          🔧 Admin Mode: Logged in as <strong>{adminImpersonation.display_name || adminImpersonation.email}</strong>
        </span>
        <Button 
          size="small" 
          variant="outlined" 
          color="inherit"
          onClick={logout}
          sx={{ ml: 2 }}
        >
          Exit Admin Mode
        </Button>
      </Box>
    </Alert>
  );
};

export default AdminImpersonationBanner;